export default defineNuxtRouteMiddleware((to) => {
  if (!to.meta.hallSortOrder) {
    return
  }

  const { defaultSortOrder, sortOrderParameter, validSortOrderParameters } = to.meta.hallSortOrder

  const queryParameterValue = to.query[sortOrderParameter]
  if (queryParameterValue === undefined) {
    return
  }

  const navigate = (sortOrder: string | undefined) => {
    return navigateTo({ ...to, query: { ...to.query, [sortOrderParameter]: sortOrder === defaultSortOrder ? undefined : sortOrder } })
  }

  if (Array.isArray(queryParameterValue)) {
    for (const o of queryParameterValue) {
      if (o === null) {
        continue
      }

      if (validSortOrderParameters.includes(o)) {
        return navigate(o)
      }
    }

    return navigate(undefined)
  } else if (queryParameterValue === null || !validSortOrderParameters.includes(queryParameterValue) || queryParameterValue === defaultSortOrder) {
    return navigateTo(undefined)
  }
})
